import { TranslationPipe } from 'src/shared/pipes/translation.pipe';

export const myProDropDownMenu = [
  {
    label: new TranslationPipe().transform('Settings'),
    action: 'goToProSettings'
  },
  {
    label: new TranslationPipe().transform('Block Pro'),
    action: 'blockPro'
  },
]

// Returns a new array so the shared menu isn't mutated across pros.
// Blocked pros get no menu: the page offers "Approve & Unblock" instead.
export function getMyProDropDownMenu(isPrivatePro: boolean, isBlocked = false): { label: string; action: string }[] {
  if (isBlocked) {
    return [];
  }
  return isPrivatePro
    ? [...myProDropDownMenu]
    : myProDropDownMenu.filter((item) => item.action !== 'goToProSettings');
}
